import { createApp } from 'vue/dist/vue.esm-bundler'
import App from './App.vue'

export const app = createApp(App)
